var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "third",
    class: {
      'mb': _vm.wayType === 'm-phone' || _vm.wayType === 'm-email' || _vm.wayType === ''
    }
  }, [_c('div', {
    staticClass: "or"
  }, [_c('div', {
    staticClass: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "mid"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.other'))))])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "way-wrap clear"
  }, _vm._l(_vm.loginWays, function (way, index) {
    return _c('a', {
      key: index,
      staticClass: "way",
      class: way.name,
      attrs: {
        "href": way.url
      },
      on: {
        "click": function click($event) {
          return _vm.thirdLogin(way.name);
        }
      }
    });
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };